import axios  from "@/axios";

export default {
    namespaced: true,

    actions: {
        fetchStatusAtt({ commit }, { id }) {
            return axios.get(`/Attendances/workday/status/${id}`)
        },
        updateStatus({ commit }, { id }) {
            return axios.put(`/Attendances/workday/${id}/checked`)
        },
        delete({ commit }, { id }) {
            return axios.delete(`/SettingsAttend/PermenantSystem/${id}`)
        },
        createHybridSystemAttend({ commit }, { permanentSystem, hybirdSystems, dailySystems }) {
            return axios.post('/SettingsAttend/HybridSystem', { permanentSystem, hybirdSystems, dailySystems }).then((data) => {
                return data
            })
        }
    } 
}